<template>
	<div>
		<ProgramFilters @submit="handleFormSubmit" />
	</div>
</template>

<script setup lang="ts">
import ProgramFilters from '@ProgramList/components/ProgramFilters.vue';
import { useFormSubmit } from '@ProgramList/composables/useFormSubmit';

const { handleFormSubmit } = useFormSubmit();
</script>
